module.exports = __webpack_public_path__ + "static/media/camels.f210a581.png";